import React, { useState } from 'react';
import {
  DistributionReasonDTO,
  useWithdrawalOptionsQuery,
} from '../../api/useWithdrawalOptionsQuery';
import { WithdrawParams } from '../../api/useWithdrawMutation';
import { ErrorModal } from '../ErrorModal/ErrorModal';
import { LoadingModal } from '../LoadingModal/LoadingModal';
import { TabType, TransferModal } from '../TransferModal/TransferModal';
import { WithdrawMetadata } from './components/WithdrawForm/useWithdrawForm';
import { WithdrawForm } from './components/WithdrawForm/WithdrawForm';
import { WithdrawSelection } from './components/WithdrawSelection/WithdrawSelection';
import { WithdrawPreview } from './WithdrawPreview';

interface Props {
  onClose(): void;
  onBack(): void;
}

export const Withdraw: React.FC<Props> = ({ onClose, onBack }) => {
  const { isLoading, isError, refetch, data } = useWithdrawalOptionsQuery();

  const [withdrawDetails, setWithdrawDetails] = useState<{
    params: WithdrawParams;
    metadata: WithdrawMetadata;
  } | null>(null);

  const [distributionReason, setDistributionReason] = useState<DistributionReasonDTO>();

  if (isLoading) {
    return <LoadingModal />;
  }

  if (isError) {
    return <ErrorModal onClose={onClose} onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  const { isIraAccount, distributionReasons, stateWitholdingDetails } = data;

  return (
    <>
      {distributionReasons && !distributionReason ? (
        <WithdrawSelection
          onClose={onClose}
          onBack={onBack}
          onDistributionReasonChange={setDistributionReason}
        />
      ) : (
        <TransferModal tab={TabType.Withdraw} onClose={onClose} onBack={onBack}>
          {props => (
            <>
              {withdrawDetails && (
                <WithdrawPreview
                  {...props}
                  withdrawDetails={withdrawDetails}
                  onBack={() => setWithdrawDetails(null)}
                />
              )}
              <WithdrawForm
                {...props}
                isVisible={withdrawDetails === null}
                onSuccess={setWithdrawDetails}
                isIraAccount={isIraAccount}
                distributionReason={distributionReason}
                stateWitholdingDetails={stateWitholdingDetails}
              />
              )
            </>
          )}
        </TransferModal>
      )}
    </>
  );
};
